export default { 
  API_BASE_URL: "https://shielded-sea-30587.herokuapp.com/api"
  };